<template>
  <div class="gestionar-materia-prima container-fluid mt-4 p-4 rounded shadow-sm">

    <!-- Titulo -->
    <h2 class="materia-prima-dark mb-3">
      <font-awesome-icon icon="fas fa-cogs" class="me-2" />
      Gestionar Materia Prima
    </h2>

    <!-- Alerta -->
    <div v-if="pendingCount > 0"
      class="alert alert-light border border-danger d-flex align-items-center p-3 mb-4 rounded">
      <font-awesome-icon icon="fas fa-exclamation-circle" class="me-3 text-danger" />
      <div>
        <strong class="text-danger">{{ pendingCount }} unidad<span v-if="pendingCount > 1">es</span> de biomasa
          pendientes de procesar.</strong>
        <br>
        <button class="btn btn-link btn-sm p-0 text-danger fw-semibold mt-1" @click="showPendientes">
          <font-awesome-icon icon="fas fa-seedling" class="me-1" /> Ver Biomasa Pendiente
        </button>
      </div>
    </div>

    <!-- Botonera -->
    <div class="d-flex flex-wrap gap-2 mb-4">
      <button class="btn btn-outline-materia-prima" @click="showList">
        <font-awesome-icon icon="fas fa-list" class="me-1" /> Listar Materia Prima
      </button>
      <button class="btn btn-outline-secondary" @click="toggleStock">
        <font-awesome-icon :icon="['fas', sinStock ? 'eye' : 'eye-slash']" class="me-1" />
        {{ sinStock ? 'Ver Con Stock' : 'Ver Sin Stock' }}
      </button>

      <button class="btn btn-materia-prima" @click="showCreate">
        <font-awesome-icon icon="fas fa-plus-circle" class="me-1" /> Crear Nueva Materia Prima
      </button>

    </div>

    <!-- Vista dinamica -->
    <component :is="actualViewComponent" :materia_id="selectedmateria_id" :materia_prima="selected_materia_prima"
      v-bind="actualView === 'listar' ? { 'sin-stock': sinStock } : {}"
      @viewChange="handleViewChange"
      @editar="handleViewChange"
      @copiarCodigo="handleViewChange" @transformar="handleViewChange"
      @cancelar="showList" @materiaPrimaCreada="showList" @materiaPrimaEditada="showList" @procesoFinalizado="showList"
      @productoFinalBulkCreado="showList" @ajusteRealizado="showList"/>

    <div class="d-flex justify-content-end mt-3" v-if="actualView !== 'listar'">
      <button class="btn btn-outline-secondary" @click="showList">
        <font-awesome-icon icon="fas fa-arrow-left" class="me-1" /> Volver a Listar
      </button>
    </div>

  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import axios from '@/axios';
import { mapGetters } from 'vuex';
import ListarMateriaPrima from '@/components/MateriaPrima/ListarMateriaPrima.vue';
import FormMateriaPrima from '@/components/MateriaPrima/FormMateriaPrima.vue';
import ListaEsperaMateriaPrimaBiomasa from '@/components/Biomasa/ListaMateriaPrimaWrapper.vue';
import ProcesarMateriaPrima from '@/components/MateriaPrima/ProcesarMateriaPrima.vue';
import FormMateriaPrimaEditar from '@/components/MateriaPrima/FormMateriaPrimaEditar.vue';
import AjustarCantidadMateriaPrima from '@/components/MateriaPrima/AjustarCantidadMateriaPrima.vue';
import ProductoFinalBulkCrear from '@/components/ProductoFinal/FormProductoFinalBulkCrear.vue';

export default {
  name: 'GestionarMateriaPrima',
  components: {
    FontAwesomeIcon,
    ListarMateriaPrima,
    FormMateriaPrima,
    ListaEsperaMateriaPrimaBiomasa,
    ProcesarMateriaPrima,
    FormMateriaPrimaEditar,
    AjustarCantidadMateriaPrima,
    ProductoFinalBulkCrear
  },
  data() {
    return {
      actualView: 'listar',      // 'listar' | 'crear' | 'editar' | 'pendiente'
      selectedmateria_id: null,
      selected_materia_prima: null,
      pendingCount: 0,
      sinStock: false // Controla si se muestran materias primas sin stock
    };
  },
  computed: {
    ...mapGetters(['getClubActual']),
    actualViewComponent() {
      switch (this.actualView) {
        case 'crear':
          return 'FormMateriaPrima';
        case 'editar':
          return 'AjustarCantidadMateriaPrima';
        case 'pendiente':
          return 'ListaEsperaMateriaPrimaBiomasa';
        case 'procesar':
          return 'ProcesarMateriaPrima';
        case 'producto_final_bulk':
          return 'ProductoFinalBulkCrear';
        default:
          return 'ListarMateriaPrima';
      }
    }
  },
  methods: {
    showList() {
      this.fetchPendingCount();
      this.actualView = 'listar';
      this.selectedmateria_id = null;
    },
    showCreate() {
      this.actualView = 'crear';
      this.selectedmateria_id = null;
    },
    showPendientes() {
      this.actualView = 'pendiente';
      this.selectedmateria_id = null;
    },
    showProcesarMateriaPrima() {
      this.actualView = 'procesar';
      this.selectedmateria_id = null;
    },
    handleViewChange({ view, materia_prima }) {

      this.actualView = view;
      if(!materia_prima) {
        this.selectedmateria_id = null;
        this.selected_materia_prima = null;
        return;
      }
      
      this.selectedmateria_id = materia_prima.id || null;
      this.selected_materia_prima = materia_prima || null;

    },
    toggleStock() {
      this.sinStock = !this.sinStock;
      if (this.actualView === 'listar') {
        // Forzar el refetch si ya estamos listando
        this.actualView = '';
        this.$nextTick(() => {
          this.actualView = 'listar';
        });
      }
    },

    async fetchPendingCount() {
      try {
        const res = await axios.get('/api/lista_biomasa_espera_materia_prima', {
          params: { club_id: this.getClubActual.id }
        });
        this.pendingCount = (res.data || []).length;
      } catch (e) {
        console.error('Error al obtener biomasa pendiente:', e);
      }
    }
  },
  mounted() {
    this.fetchPendingCount();
  }
};
</script>


<style scoped>
.materia-prima-dark {
  color: #a84e1a;
}

.btn-materia-prima {
  background-color: #a84e1a;
  color: white;
}

.btn-materia-prima:hover {
  background-color: #843d15;
}

.btn-outline-materia-prima {
  border-color: #a84e1a;
  color: #a84e1a;
}

.btn-outline-materia-prima:hover {
  background-color: #a84e1a;
  color: white;
}
.btn-outline-secondary:hover {
  background-color: #ddd;
}

</style>